<template>
    <div>
        <div :id="cid" :style="cstyle"></div>
    </div>
  </template>
  <script>
  import * as echarts from "echarts";
  export default {
    name: "concEcharts",
    props: {
      cstyle:{
        type:String,
        default:'width: 800px;height:400px;'
      },
      coption:{
        type:Object,
        default:()=>{
          return {}
        }
      },
      cid:{
        type:String,
        default:'main'
      },
    },
    data() {
      return {
        chartDom:"",
        myChart:"",
        option:""
      };
    },
    mounted() {
      this.$nextTick(() => {
        this.chartDom = document.getElementById(this.cid);
        this.myChart = echarts.init(this.chartDom);
        this.initChart();
      })
    },
    methods: {
        initChart(){
            this.option = this.coption;
            this.option && this.myChart.setOption(this.option);
        }
    },
  };
  </script>
  <style scoped>
  
  </style>


// WEBPACK FOOTER //
// src/components/concEcharts/concEcharts.vue